import { useMutation } from '@tanstack/react-query';
import AiInsightService from '@/services/AiInsightService';
import type { ConversationMessage } from '@/services/AiInsightService';

export function useFetchSuggestedReplies() {
  return useMutation({
    mutationFn: (vars: {
      withingsUserId: string | number;
      conversation?: ConversationMessage[];
    }) => AiInsightService.getSuggestedReplies(vars.withingsUserId, vars.conversation),
  });
}
